export default __webpack_public_path__ + "static/media/NIE_touchpoint_03.8cdb58f7.mp4";